
const appName   = process.env.VUE_APP_APPLICATION_NAME;
let {getApplication} = require ('@/client/applications/'+appName+'/'+appName+'.js');

export default getApplication();




